module.exports = __webpack_public_path__ + "static/media/rst.028660e4.svg";